import { render, staticRenderFns } from "./liuliangka.vue?vue&type=template&id=23473e1b&scoped=true&"
import script from "./liuliangka.vue?vue&type=script&lang=js&"
export * from "./liuliangka.vue?vue&type=script&lang=js&"
import style0 from "./liuliangka.vue?vue&type=style&index=0&id=23473e1b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23473e1b",
  null
  
)

export default component.exports